import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=2e72b654"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=2e72b654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports